import { createTranslationResource } from '@backstage/frontend-plugin-api';
import { orgTranslationRef } from '@backstage/plugin-org';

export const orgTranslations = createTranslationResource({
  ref: orgTranslationRef,
  translations: {
    'pt-BR': () => import('./pt-BR'),
  },
});
